import { GetStaticPaths } from "next";
import Head from "next/head";

import Post from "../../components/Releases/Post";
import {
  createGetStaticPathsFunction,
  getStaticPropsForPostPage as getStaticProps,
  PostPageProps,
  PostType,
} from "../../utils/posts";
import { FlashPCBPage } from "../../models/page";

const PressReleasesPage: FlashPCBPage<PostPageProps> = ({ post }) => {
  return (
    <>
      <Head>
        <title>{post.title}</title>
        <meta
          name="description"
          content={post.subtitle || "FlashPCB press release"}
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Post post={post} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = createGetStaticPathsFunction(
  PostType.PRESS,
);

export { getStaticProps };

export default PressReleasesPage;
